import React, { useState } from "react";
import { authFetch } from "../lib/authApi";

export default function AdminUsers() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("user");
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr(""); setMsg("");
        try {
            const r = await authFetch("/api/admin/users", {
                method: "POST",
                body: JSON.stringify({ email, password, role }),
            });
            setMsg(`Erstellt: ${r.email} (${r.role})`);
            setEmail(""); setPassword("");
        } catch (e) {
            setErr(e.message);
        }
    }

    return (
        <div className="card">
            <h1>Admin: User anlegen</h1>
            {err && <div className="alert alert--error">{err}</div>}
            {msg && <div className="alert alert--ok">{msg}</div>}

            <form onSubmit={onSubmit} className="form">
                <label className="form-label">E-Mail</label>
                <input className="input" value={email} onChange={(e)=>setEmail(e.target.value)} />

                <label className="form-label">Passwort</label>
                <input className="input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} />

                <label className="form-label">Rolle</label>
                <select className="input" value={role} onChange={(e)=>setRole(e.target.value)}>
                    <option value="user">user</option>
                    <option value="admin">admin</option>
                </select>

                <button className="btn" type="submit">Anlegen</button>
            </form>
        </div>
    );
}